import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/navbar.scss";

export const Navbar = () => {
  const [show, setShow] = useState(true);
  const [hasBackground, setHasBackground] = useState(false);

  return (
    <div
      className={`navbar-container ${
        hasBackground ? "showbackground" : "hidebackground"
      } ${show ? "active" : "hidden"}`}
    >
      <div className="navbar-width">
        <div className="navbar">
          <div className="navbar-big-pill">
            <NavLink className="navbar-left" to="/">
              <p>elias vorderegger</p>
            </NavLink>
          </div>
        </div>
        <div className="navbar-mobile">
          <div className="navbar-big-pill">
            <NavLink className="navbar-left" to="/">
              <p>elias vorderegger</p>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};
